import React, { useState, useContext, useEffect } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";
import styled from "styled-components";

const HelpLayout = styled.div`
  .material-icons {
    vertical-align: middle;
    font-size: 1.1em;
  }

  .boxplots-image{
    width: 100%;
  }
`;

const Help = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  const doClose = () => setOpen(false);

  useEffect(() => {
    return actions.recv("open-help", function () {
      setOpen(true);
    });
  }, []);

  return open !== true ? null : (
    <Modal
      title="Application Speed Metrics"
      onClose={doClose}
      content={() => (
        <HelpLayout>
          <p>This view shows the distribution of speeds by application.</p>

          <p>Selectors:</p>
          <ul>
            <li>
              <i className="material-icons valign-icon">date_range</i> Selects
              the range of time values shown starting from now: 1 day, 1 week or
              1 month.
            </li>
            <li>
              <i className="material-icons valign-icon">group</i> Selects the
              subscriber group.
            </li>
            <li>
              <i className="material-icons valign-icon">folder_open</i> Selects
              the rate policies.
            </li>
          </ul>

          <img className="boxplots-image" src="/images/boxplots.png"/>

          <p>Percentiles:</p>
          <ul>
            <li>max: Max speed registered.</li>
            <li>p90: Speed registered in the 90th percentile.</li>
            <li>p75: Speed registered in the 75th percentile.</li>
            <li>p50: Speed registered in the 50th percentile.</li>
            <li>p25: Speed registered in the 25th percentile.</li>
            <li>p10: Speed registered in the 10th percentile.</li>
            <li>min: Min speed registered.</li>
          </ul>
          <p> A percentile gives a metric value that is bigger than a given percentage of registed metrics. For example, a p25 percetile of 30,4 Mbps indicates that 25% of registered speeds are lower than 30,4 Mbps (and therefore 75% are bigger). </p>

          <p>Views:</p>
          <ul>
          <li>Boxplot view</li>
          <li>Line chart view</li>
          </ul>

          <p>
            Click on <i className="material-icons valign-icon">refresh</i> icon
            to refresh information.
          </p>
        </HelpLayout>
      )}
    />
  );
};
export default Help;
